import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiStateService } from '../shared/ui-state.service';
import { PassportService } from '../shared/passport.service';
import { SyncService } from '../shared/sync.service';

@Component({
  selector: 'app-status-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-tabs.component.html',
  styleUrl: './status-tabs.component.css'
})
export class StatusTabsComponent implements OnInit {
  @Input() pendingCount = 0;
  @Input() outgoingCount = 0;
  @Input() completedCount = 0;

  constructor(
    public ui: UiStateService, 
    public passports: PassportService,
    private readonly syncService: SyncService
  ) {}

  // Directly use the UI state service's signal
  get selected() {
    return this.ui.statusSelected;
  }

  // Check if we're in mobile mode (offline features only available in mobile)
  get isMobileMode(): boolean {
    return window.innerWidth < 768;
  }

  ngOnInit(): void {
    // Initialize with pending tab if not already set
    if (!this.ui.statusSelected()) {
      this.ui.setStatusSelected('pending');
    }
  }

  setSelected(tab: 'pending' | 'outgoing' | 'completed'): void {
    this.ui.setStatusSelected(tab);
  }

  async onResync(): Promise<void> {
    if (!navigator.onLine) {
      return; // stay in Outgoing until back online
    }
    
    // Call SyncService to submit pending/outgoing passports to backend
    try {
      await this.syncService.manualSync();
    } catch (error) {
      console.warn('Resync failed:', error);
      alert('Failed to resync passports. Please try again.');
    }
  }
}


